<template>
<canvas @click="openInsta" id="glcanvas"></canvas>
</template>

<script>
export default {
  name: 'webGl',
  data() {
    return {
      clickable: false
    }
  },
  methods: {
    openInsta() {
      if (this.clickable) window.open("https://www.instagram.com/wideawake.earth/")
    }
  },
  mounted() {
    function showError(errId, errMsg) {
      alert('An error occured: ' + errId + ', ' + errMsg);
    }

    function patchInitialized() {
      // You can now access the patch object (CABLES.patch), register variable watchers and so on
    }

    function patchFinishedLoading() {
      // The patch is ready now, all assets have been loaded
    }

    document.addEventListener('DOMContentLoaded', function(event) {
      CABLES.patch = new CABLES.Patch({
        patchFile: 'js/Hantel_Coming_Soon.json',
        prefixAssetPath: '',
        glCanvasId: 'glcanvas',
        glCanvasResizeToWindow: true,
        onError: showError,
        onPatchLoaded: patchInitialized,
        onFinishedLoading: patchFinishedLoading,
      });
    });

    setTimeout(() => {
      document.querySelector('canvas').style.cursor = 'pointer'
      this.clickable = true
    }, 10000)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#glcanvas {
    width: 100% !important;
    height: 100% !important;
    margin: 0;
    overflow: hidden;
}
</style>
